// import store from "@/store";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { _lang } from '@/utils/lang'

// 核心页面路由
const getCoreRoutes = (): RouteRecordRaw[] => [
  {
    path: "/",
    name: "sparkshort",
    component: () =>
      import(/* webpackChunkName: "spark-core-website" */ "../views-spark-short/website/index.vue"),
    meta: {
      title: 'Sparkshort',
    },
  },
];

// 反馈相关路由
const getFeedbackRoutes = (): RouteRecordRaw[] => [
  {
    path: "/issue",
    name: "ISSUE",
    component: () =>
      import(/* webpackChunkName: "spark-feedback-issue" */ "../views-spark-short/issue/index.vue"),
    meta: {
      title: _lang('FEEDBACK'),
    },
  },
  {
    path: "/feedBacks",
    name: "Message",
    component: () =>
      import(/* webpackChunkName: "spark-feedback-messages" */ "../views-spark-short/feedBacks/index.vue"),
    meta: {
      title: _lang('Message'),
    },
  },
  {
    path: "/evaluate",
    name: "EVALUATE",
    component: () =>
      import(/* webpackChunkName: "spark-feedback-evaluate" */ "../views-spark-short/evaluate/index.vue"),
    meta: {
      title: _lang('Rating'),
    },
  },
];

// 问卷调查相关路由
const getQuestionnaireRoutes = (): RouteRecordRaw[] => [
  {
    path: "/questionnaire",
    name: "WELCOME",
    component: () =>
      import(/* webpackChunkName: "spark-questionnaire-main" */ "../views-spark-short/questionnaire/index.vue"),
    meta: {
      title: _lang('Survey'),
    },
  },
  {
    path: "/questionnaire/question",
    name: "FILL Survey",
    component: () =>
      import(/* webpackChunkName: "spark-questionnaire-question" */ "../views-spark-short/questionnaire/question.vue"),
    meta: {
      title: _lang('Survey'),
    },
  },
  {
    path: "/questionnaire/thanks",
    name: "THANKS",
    component: () =>
      import(/* webpackChunkName: "spark-questionnaire-thanks" */ "../views-spark-short/questionnaire/thanks.vue"),
    meta: {
      title: _lang('Survey'),
    },
  },
];

// 法律和分享相关路由
const getLegalAndSharingRoutes = (): RouteRecordRaw[] => [
  {
    path: "/secret",
    name: "SECRET",
    component: () =>
      import(/* webpackChunkName: "spark-legal-privacy" */ "../views-spark-short/secret/index.vue"),
    meta: {
      title: _lang('privacyPolicy'),
    },
  },
  {
    path: "/readme",
    name: "README",
    component: () =>
      import(/* webpackChunkName: "spark-legal-terms" */ "../views-spark-short/readme/index.vue"),
    meta: {
      title: _lang('termsServices'),
    },
  },
  {
    path: "/share",
    name: "SHARE",
    component: () =>
      import(/* webpackChunkName: "spark-social-share" */ "../views-spark-short/share/index.vue"),
    meta: {
      title: 'SHARE',
    },
  },
];

// 组合所有路由
const routes: Array<RouteRecordRaw> = [
  ...getCoreRoutes(),
  ...getFeedbackRoutes(),
  ...getQuestionnaireRoutes(),
  ...getLegalAndSharingRoutes(),
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title as string
  } else {
    document.title = ''
  }
  next()
})

export default router;
